@if (this.selectedDate != null) {
  <h3 class="text-lg">{{this.selectedDate.toDateString()}}</h3>
}
@for (e of events; track e) {
  <div class="mt-2 w-full">
    <app-scheduled-audit [event]="e" (DeleteEvent)="deleteEvent($event)" [showDate]="false"></app-scheduled-audit>
  </div>
}